module.exports = __webpack_public_path__ + "media/images/icons/call-received-4259c14e50927d07bedc20fc24aee15e.svg";